<div class="panneau-choix-medecin__container">
	<div class="container__content">
		<di-liste-contacts
			[contactsList]="contacts"
			(contactSelection)="selectContact($event)"
			[displayHeader]="false"
			(clickAddContact)="handleClickAddContact()"
		></di-liste-contacts>
	</div>
	<lua-bouton-floating
		class="btn-ajout-contact-mobile"
		bottom="30px"
		right="30px"
		iconName="add"
		(click)="handleClickAddContact()"
	>
	</lua-bouton-floating>
</div>
